import { ld } from "@/lib/theme/light-dark";

/** Shared layout/color tokens for hero Vorgang thread mocks (aligned with prod inbox comments). */
export const HERO_VORGANG_RAIL_WIDTH_PX: number = 210;

export const HERO_VORGANG_BUBBLE_INBOUND_BG: string = ld("rgba(244,244,245,0.8)", "rgba(39,39,42,0.5)");
export const HERO_VORGANG_BUBBLE_OUTBOUND_BG: string = ld("#ECF8F6", "rgba(0,26,23,0.5)");
export const HERO_VORGANG_CHANNEL_HEADER_BG: string = "rgba(58,158,107,0.02)";
export const HERO_VORGANG_CHANNEL_HEADER_BORDER: string = ld("rgba(11,15,25,0.08)", "rgba(250,250,250,0.08)");
export const HERO_VORGANG_MUTED_BLOCK_BG: string = ld("#F4F4F5", "#292c30");

export const HERO_VORGANG_THREAD_GAP_PX: number = 16;
export const HERO_VORGANG_THREAD_PADDING_X_PX: number = 20;
/** Scroll clearance so the last message stays visible under the floating action row. */
export const HERO_VORGANG_ACTION_FOOTER_CLEARANCE_PX: number = 56;
